import { Controller } from 'react-hook-form';

import { Card, FormItem, ListLayout, OptionList, SearchSelect, SelectTrigger } from '@ingrid/luterkort-react';
import { ShippingLogo } from '@ingrid/react-shipping-logo';

import { ValidationError } from '~src/components/ValidationError/ValidationError';
import { useTranslation } from '~src/i18n/use-translation';

import { useCarrierContractsListSchemasQuery } from '../schema/queries';
import { useCarrierContractFormContext } from '../types';
import { CarrierProducts } from './carrier-products';
import { Validate } from './validate';

export function Carrier() {
  const { formState, watch, control, resetField } = useCarrierContractFormContext();
  const { data: schemas } = useCarrierContractsListSchemasQuery();
  const { t } = useTranslation();

  const invalid = !!formState.errors.schema_id?.message;
  const schemaId = watch('schema_id');

  return (
    <Card.Wrapper>
      <Card.Header>{t('common.carrierProduct')}</Card.Header>

      <Card.Content>
        <ListLayout.Column>
          <FormItem.Root>
            <Controller
              control={control}
              name="schema_id"
              render={({ field }) => (
                <FormItem.Control>
                  <SearchSelect.Root
                    onValueChange={value => {
                      resetField('carrier_configuration_data');
                      field.onChange(value[0]);
                    }}
                    value={schemaId ? [schemaId] : undefined}
                    key={schemaId}
                  >
                    <SearchSelect.Trigger asChild onBlur={field.onBlur} ref={field.ref} aria-required="true">
                      <SelectTrigger.Button {...(invalid && { 'data-invalid': 'true' })}>
                        <SelectTrigger.Placeholder>{t('common.selectCarrier')}</SelectTrigger.Placeholder>
                        {schemas.map(({ schema_id, carrier_name, carrier_products }) => (
                          <SelectTrigger.Value key={schema_id} value={schema_id!}>
                            <SelectTrigger.Logo>
                              <ShippingLogo method={carrier_products?.[0].shipping_method} width={24} />
                            </SelectTrigger.Logo>
                            <span>{carrier_name}</span>
                          </SelectTrigger.Value>
                        ))}
                        <SelectTrigger.Icon />
                      </SelectTrigger.Button>
                    </SearchSelect.Trigger>

                    <SearchSelect.Content style={{ maxHeight: 350, width: '608px' }}>
                      <OptionList.Viewport>
                        {schemas.map(({ schema_id, carrier_name, carrier_products }) => (
                          <OptionList.Item key={schema_id} spacing="sm" value={schema_id!}>
                            <ShippingLogo method={carrier_products?.[0].shipping_method} width={24} />
                            <OptionList.ItemText>{carrier_name}</OptionList.ItemText>
                            <OptionList.ItemIndicator>
                              <OptionList.CheckmarkIcon />
                            </OptionList.ItemIndicator>
                          </OptionList.Item>
                        ))}
                      </OptionList.Viewport>
                    </SearchSelect.Content>
                  </SearchSelect.Root>
                </FormItem.Control>
              )}
              rules={Validate().schema_id}
            />

            <ValidationError errors={formState.errors} name="schema_id" />
          </FormItem.Root>

          <CarrierProducts schemaId={schemaId} />
        </ListLayout.Column>
      </Card.Content>
    </Card.Wrapper>
  );
}
